import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "cusTree" };
import { reactive, ref, watch } from 'vue';
import _includes from 'lodash/includes';
import _forEach from 'lodash/forEach';
import _without from 'lodash/without';
import { nextTick } from '@vue/runtime-core';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ElementPlusTree',
    props: {
        permission: {
            type: Object,
            default() {
                return {};
            }
        },
        identity: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        state: {
            type: String,
            default: ''
        },
        defaultCheckedKeys: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    emits: ['setCheckedKeys'],
    setup(__props, { emit: $MyEmit }) {
        const props = __props;
        const defaultProps = reactive({
            children: 'subs',
            label: 'name',
            disabled: (date, node) => setDis(date, node)
        });
        const formatPermission = reactive([]);
        const permissionIds = reactive([]);
        // const permissionTreeRef = ref<InstanceType<typeof ElTree>>()
        const formatPer = (item, formatItem) => {
            if (item.subs) {
                formatItem.subs = Object.values(item.subs);
                formatItem.subs.forEach((nextItem, nextIndex) => {
                    if (props.disabled) {
                        nextItem.disabled = true;
                    }
                    formatPer(nextItem, formatItem.subs[nextIndex]);
                });
            }
            return formatItem;
        };
        const permissionTreeRef = ref(null);
        watch(() => props.permission, (val) => {
            if (val) {
                const permissionArr = Object.values(val[`n-${props.identity}` || props.identity].subs);
                const formatPerArr = [];
                permissionArr.forEach((item, index) => {
                    if (props.disabled) {
                        item.disabled = true;
                    }
                    // item.disabled = setDis
                    formatPerArr[index] = item;
                    formatPerArr[index] = formatPer(item, formatPerArr[index]);
                });
                formatPermission.length = 0;
                formatPermission.push(...formatPerArr);
                // permissionTreeRef.value.channelTree.setCheckedNodes(formatPermission)
                nextTick(() => {
                    setBykey();
                });
                // if (props.state === 'add') {
                //   nextTick(() => {
                //     checkAllNode(formatPermission)
                //   })
                // }
            }
        });
        const checkAllNode = (checkNode) => {
            permissionTreeRef.value.setCheckedNodes(checkNode, false);
        };
        const setBykey = () => {
            permissionTreeRef.value.setCheckedKeys(props.defaultCheckedKeys, true);
        };
        watch(() => props.defaultCheckedKeys, (val) => {
            nextTick(() => {
                setBykey();
            });
        });
        const checkChange = () => {
            let checkedNodeKeys = [];
            let checkedNodeKeysNoHalf = [];
            const checkedKeys = [];
            const checkedKeysNoHalf = [];
            checkedNodeKeys = permissionTreeRef.value.getCheckedNodes(false, false);
            checkedNodeKeysNoHalf = permissionTreeRef.value.getCheckedNodes(false, true);
            nextTick(() => {
                checkedNodeKeys.forEach((item) => {
                    checkedKeys.push(item.id);
                });
                checkedNodeKeysNoHalf.forEach((item) => {
                    checkedKeysNoHalf.push(item.id);
                });
                $MyEmit('setCheckedKeys', checkedKeys, checkedKeysNoHalf);
            });
        };
        const childNodesIds = ref([]);
        const nodeClick = (obj, node, event) => {
            if (node.disabled)
                return;
            if (node.childNodes.length > 0) {
                getChildNodesIds(node.childNodes);
                const ks = [];
                const cnks = permissionTreeRef.value.getCheckedNodes(false, false);
                cnks.forEach((item) => {
                    ks.push(item.id);
                });
                if (node.checked) {
                    permissionTreeRef.value.setCheckedKeys([...ks, ...childNodesIds.value], true);
                    childNodesIds.value = [];
                    // setBykey()
                }
                else {
                    const keys = _without(ks, ...childNodesIds.value, node.data.id);
                    permissionTreeRef.value.setCheckedKeys(keys, true);
                    childNodesIds.value = [];
                    // setBykey()
                }
            }
            let checkedNodeKeys = [];
            const checkedKeys = [];
            checkedNodeKeys = permissionTreeRef.value.getCheckedNodes(false, false);
            checkedNodeKeys.forEach((item) => {
                checkedKeys.push(item.id);
            });
            $MyEmit('setLeftMap', checkedKeys);
        };
        const getChildNodesIds = (child) => {
            _forEach(child, item => {
                if (item.childNodes) {
                    childNodesIds.value.push(item.data.id);
                    getChildNodesIds(item.childNodes);
                }
            });
        };
        const setDis = (data, node) => {
            if (props.disabled)
                return true;
            const ks = [];
            const cnks = permissionTreeRef.value.getCheckedNodes(false, false);
            cnks.forEach((item) => {
                ks.push(item.id);
            });
            if (_includes([...ks, props.identity], data.parentId)) {
                return false;
            }
            else {
                return true;
            }
        };
        return (_ctx, _cache) => {
            const _component_ElTree = _resolveComponent("ElTree");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ElTree, {
                    ref_key: "permissionTreeRef",
                    ref: permissionTreeRef,
                    data: formatPermission,
                    "show-checkbox": "",
                    "check-on-click-node": true,
                    "expand-on-click-node": false,
                    "default-checked-keys": __props.defaultCheckedKeys,
                    "check-strictly": true,
                    "node-key": "id",
                    "default-expand-all": "",
                    props: defaultProps,
                    onNodeClick: nodeClick,
                    onCheckChange: checkChange
                }, null, 8, ["data", "default-checked-keys", "props"])
            ]));
        };
    }
});
